/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Level_BeginnerInputs */

const en_us2_profile_level_beginner = /** @type {(inputs: Profile_Level_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginner`)
};

const pt_br2_profile_level_beginner = /** @type {(inputs: Profile_Level_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciante`)
};

const es_419_profile_level_beginner = /** @type {(inputs: Profile_Level_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante`)
};

const pt_pt2_profile_level_beginner = /** @type {(inputs: Profile_Level_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciante`)
};

const fr_fr2_profile_level_beginner = /** @type {(inputs: Profile_Level_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débutant`)
};

const de_de2_profile_level_beginner = /** @type {(inputs: Profile_Level_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfänger`)
};

const it_it2_profile_level_beginner = /** @type {(inputs: Profile_Level_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante`)
};

/**
* | output |
* | --- |
* | "Beginner" |
*
* @param {Profile_Level_BeginnerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_level_beginner = /** @type {((inputs?: Profile_Level_BeginnerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Level_BeginnerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_level_beginner(inputs)
	if (locale === "es-419") return es_419_profile_level_beginner(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_level_beginner(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_level_beginner(inputs)
	if (locale === "de-DE") return de_de2_profile_level_beginner(inputs)
	if (locale === "it-IT") return it_it2_profile_level_beginner(inputs)
	return en_us2_profile_level_beginner(inputs)
});
export { profile_level_beginner as "profile.level_beginner" }